"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot } from "@/components/ui/input-otp";
import { Label } from "@/components/ui/label";

/**
 * Email OTP sign-in, inline. It takes the place of the "Sign in with Email"
 * button rather than opening a card, so the Restore panel barely moves:
 * one label row, then the address and its submit button side by side.
 */
export function EmailOtpSection(t0) {
  const $ = _c(64);
  const {
    emailAuthPending,
    emailForOtp,
    handleEmailOtpSignIn,
    handleSendEmailOtp,
    otpCode,
    otpSent,
    resetEmailOtp,
    setEmailForOtp,
    setOtpCode,
    setOtpSent
  } = t0;
  let t1;
  if ($[0] !== emailAuthPending || $[1] !== resetEmailOtp) {
    t1 = <button className="text-muted-foreground text-xs hover:text-foreground hover:underline" disabled={emailAuthPending} onClick={resetEmailOtp} type="button">Cancel</button>;
    $[0] = emailAuthPending;
    $[1] = resetEmailOtp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const cancel = t1;
  if (otpSent) {
    let t2;
    if ($[3] !== emailForOtp) {
      t2 = <p className="text-sm">Enter the code sent to{" "}<span className="font-medium">{emailForOtp}</span></p>;
      $[3] = emailForOtp;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== cancel || $[6] !== t2) {
      t3 = <div className="flex items-center justify-between">{t2}{cancel}</div>;
      $[5] = cancel;
      $[6] = t2;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[8] !== setOtpCode) {
      t4 = value => setOtpCode(value);
      $[8] = setOtpCode;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    let t5;
    let t6;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <InputOTPGroup><InputOTPSlot index={0} /><InputOTPSlot index={1} /><InputOTPSlot index={2} /></InputOTPGroup>;
      t6 = <InputOTPSeparator />;
      $[10] = t5;
      $[11] = t6;
    } else {
      t5 = $[10];
      t6 = $[11];
    }
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <InputOTPGroup><InputOTPSlot index={3} /><InputOTPSlot index={4} /><InputOTPSlot index={5} /></InputOTPGroup>;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== emailAuthPending || $[14] !== otpCode || $[15] !== t4) {
      t8 = <div className="flex justify-center py-1"><InputOTP aria-label="Email verification code" autoFocus={true} disabled={emailAuthPending} maxLength={6} onChange={t4} value={otpCode}>{t5}{t6}{t7}</InputOTP></div>;
      $[13] = emailAuthPending;
      $[14] = otpCode;
      $[15] = t4;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== setOtpCode || $[18] !== setOtpSent) {
      t9 = () => {
        setOtpSent(false);
        setOtpCode("");
      };
      $[17] = setOtpCode;
      $[18] = setOtpSent;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== emailAuthPending || $[21] !== t9) {
      t10 = <Button disabled={emailAuthPending} onClick={t9} type="button" variant="outline">Back</Button>;
      $[20] = emailAuthPending;
      $[21] = t9;
      $[22] = t10;
    } else {
      t10 = $[22];
    }
    const t11 = otpCode.length !== 6 || emailAuthPending;
    const t12 = emailAuthPending ? "Verifying..." : "Verify & Sign In";
    let t13;
    if ($[23] !== handleEmailOtpSignIn || $[24] !== t11 || $[25] !== t12) {
      t13 = <Button className="flex-1" disabled={t11} onClick={handleEmailOtpSignIn} type="button">{t12}</Button>;
      $[23] = handleEmailOtpSignIn;
      $[24] = t11;
      $[25] = t12;
      $[26] = t13;
    } else {
      t13 = $[26];
    }
    let t14;
    if ($[27] !== t10 || $[28] !== t13) {
      t14 = <div className="flex gap-2">{t10}{t13}</div>;
      $[27] = t10;
      $[28] = t13;
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    let t15;
    if ($[30] !== emailAuthPending || $[31] !== handleSendEmailOtp) {
      t15 = <button className="text-center text-muted-foreground text-xs hover:underline disabled:opacity-50" disabled={emailAuthPending} onClick={handleSendEmailOtp} type="button">Resend code</button>;
      $[30] = emailAuthPending;
      $[31] = handleSendEmailOtp;
      $[32] = t15;
    } else {
      t15 = $[32];
    }
    let t16;
    if ($[33] !== t14 || $[34] !== t15 || $[35] !== t3 || $[36] !== t8) {
      t16 = <div className="grid gap-2" data-testid="email-otp-section">{t3}{t8}{t14}{t15}</div>;
      $[33] = t14;
      $[34] = t15;
      $[35] = t3;
      $[36] = t8;
      $[37] = t16;
    } else {
      t16 = $[37];
    }
    return t16;
  }
  let t2;
  if ($[38] !== emailAuthPending || $[39] !== emailForOtp || $[40] !== handleSendEmailOtp) {
    t2 = event => {
      event.preventDefault();
      if (emailForOtp.trim() && !emailAuthPending) {
        handleSendEmailOtp();
      }
    };
    $[38] = emailAuthPending;
    $[39] = emailForOtp;
    $[40] = handleSendEmailOtp;
    $[41] = t2;
  } else {
    t2 = $[41];
  }
  let t3;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Label htmlFor="email-otp">Email address</Label>;
    $[42] = t3;
  } else {
    t3 = $[42];
  }
  let t4;
  if ($[43] !== cancel) {
    t4 = <div className="flex items-center justify-between">{t3}{cancel}</div>;
    $[43] = cancel;
    $[44] = t4;
  } else {
    t4 = $[44];
  }
  let t5;
  if ($[45] !== setEmailForOtp) {
    t5 = e => setEmailForOtp(e.target.value);
    $[45] = setEmailForOtp;
    $[46] = t5;
  } else {
    t5 = $[46];
  }
  let t6;
  if ($[47] !== emailAuthPending || $[48] !== emailForOtp || $[49] !== t5) {
    t6 = <Input autoComplete="email" autoFocus={true} disabled={emailAuthPending} id="email-otp" inputMode="email" onChange={t5} placeholder="you@example.com" type="email" value={emailForOtp} />;
    $[47] = emailAuthPending;
    $[48] = emailForOtp;
    $[49] = t5;
    $[50] = t6;
  } else {
    t6 = $[50];
  }
  let t7;
  if ($[51] !== emailAuthPending || $[52] !== emailForOtp) {
    t7 = !emailForOtp.trim() || emailAuthPending;
    $[51] = emailAuthPending;
    $[52] = emailForOtp;
    $[53] = t7;
  } else {
    t7 = $[53];
  }
  const t8 = emailAuthPending ? "Sending..." : "Send code";
  let t9;
  if ($[54] !== t7 || $[55] !== t8) {
    t9 = <Button className="shrink-0" disabled={t7} size="sm" type="submit">{t8}</Button>;
    $[54] = t7;
    $[55] = t8;
    $[56] = t9;
  } else {
    t9 = $[56];
  }
  let t10;
  if ($[57] !== t6 || $[58] !== t9) {
    t10 = <div className="flex gap-2">{t6}{t9}</div>;
    $[57] = t6;
    $[58] = t9;
    $[59] = t10;
  } else {
    t10 = $[59];
  }
  let t11;
  if ($[60] !== t10 || $[61] !== t2 || $[62] !== t4) {
    t11 = <form className="grid gap-2" data-testid="email-otp-section" onSubmit={t2}>{t4}{t10}</form>;
    $[60] = t10;
    $[61] = t2;
    $[62] = t4;
    $[63] = t11;
  } else {
    t11 = $[63];
  }
  return t11;
}